// @flow
/** @jsx jsx */

import { AsyncIndicator } from '@zapier/common-components';
import { jsx } from '@emotion/core';
import { marginToCss } from '@zapier/common-utils';
import { Border, Colors } from '@zapier/theme';

import { PAYPAL_BUTTON_ID } from '../constants';

import type { Spacing } from '@zapier/common-utils';

const buttonCss = props => ({
  ...marginToCss(props.margin, '15px'),
  alignItems: 'center',
  background: '#009cde',
  borderRadius: Border.radius.default,
  color: Colors.white,
  display: 'flex',
  height: 49,
  justifyContent: 'center',
  position: 'relative',
  minWidth: 250,
});

type Props = {
  /** show loading indicator */
  isLoading: boolean,
  /** Margin to apply to button wrapper */
  margin?: Spacing,
};

const PaypalButtonPlaceholder = (props: Props) => (
  <div css={buttonCss(props)} id={PAYPAL_BUTTON_ID}>
    {props.isLoading && <AsyncIndicator color="inherit" />}
  </div>
);

export default PaypalButtonPlaceholder;
